import { useState } from 'react';
import { cn } from '@/lib/utils';
import { MousePointerClick } from 'lucide-react';
import { BotIdPopup } from './BotIdPopup';

interface InteractiveSnippetProps {
    text: string;
    isDashboard: boolean;
    className?: string;
}

export const InteractiveSnippet = ({ text, isDashboard, className }: InteractiveSnippetProps) => {
    const [showPopup, setShowPopup] = useState(false);

    // If text doesn't contain YOUR_BOT_ID, render normally
    if (!text.includes('YOUR_BOT_ID')) {
        return <span className={className}>{text}</span>;
    }

    return (
        <span className={cn("break-words whitespace-pre-wrap", className)}>
            {text.split('YOUR_BOT_ID').map((part, i, arr) => (
                <span key={i}>
                    {part}
                    {i < arr.length - 1 && (
                        <span className="relative inline-block align-baseline">
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation(); // prevent copy/click interference
                                    setShowPopup(v => !v);
                                }}
                                className={cn(
                                    "inline-flex items-center gap-1 mx-0.5 px-1.5 py-0.5 rounded border font-bold text-[11px] tracking-wide transition-all cursor-pointer font-sans select-none",
                                    showPopup
                                        ? "bg-amber-400/30 border-amber-400/60 text-amber-600 dark:text-amber-400"
                                        : "bg-amber-400/10 border-amber-400/30 text-amber-600 dark:text-amber-400 hover:bg-amber-400/20"
                                )}
                                title="Click to learn where to find your Bot ID"
                            >
                                <MousePointerClick className="w-2.5 h-2.5 shrink-0" />
                                YOUR_BOT_ID
                            </button>
                            {showPopup && <BotIdPopup onClose={() => setShowPopup(false)} isDashboard={isDashboard} />}
                        </span>
                    )}
                </span>
            ))}
        </span>
    );
};
